import {
  Button,
  CircularProgress,
  IconButton,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core'
import { CircleIcon } from '../icons'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { SearchPanel } from './SearchPanel'
import { strings } from '../strings'
import { useNewUser, useUserGroupsList, useUsersList } from '../api'
import { GroupForm } from '../GroupForm'
import { useToken } from '../App'
import Card from 'common/Card'
import RoomIcon from '@material-ui/icons/Room'
import { useMapContext } from 'Map/context/MapProvider'

export function Users() {
  const classes = useStyles()

  const { flyToClientPosition } = useMapContext()

  const history = useHistory()
  const [query, setQuery] = useState('')
  const [group, setGroup] = useState<number | null>(null)
  const { usersList, loading, error } = useUsersList(query, group)
  const { userGroupsList } = useUserGroupsList()
  const { userId } = useToken()
  const newUser = useNewUser()

  let dataTable

  if (loading)
    dataTable = (
      <Row>
        <CircularProgress size={20} />
      </Row>
    )
  else if (error)
    dataTable = (
      <Row>
        <Typography color="error">{error.message}</Typography>
      </Row>
    )
  else if (usersList)
    dataTable = usersList
      .sort((a, b) => {
        if (a.id === userId) return -1
        if (b.id === userId) return 1
        if (a.connected && b.connected) return 0
        if (a.connected) return -1
        return 1
      })
      .map((x) => (
        <tr key={x.id}>
          <td>
            <CircleIcon
              style={{ color: x.connected ? 'green' : 'lightgray' }}
            />
          </td>
          <td>
            <Button
              onClick={() => history.push(`user/${x.id}/profile`)}
              style={{
                textDecoration: x.fullname ? 'unset' : 'underline',
                textTransform: 'none',
              }}
            >
              {x.fullname ? x.fullname : x.username}
            </Button>
          </td>
          <td>{x.groupName}</td>
          {/* <td>{x.nationalCode}</td> */}
          <td>
            {/* Mobile */}
            <IconButton
              onClick={() => {
                history.push('/')
                setTimeout(() => {
                  flyToClientPosition(x.id)
                }, 250)
              }}
              disabled={!x.connected}
              className={classes.mobileLocation}
            >
              <RoomIcon />
            </IconButton>
            {/* Desktop */}
            <IconButton
              onClick={() => flyToClientPosition(x.id)}
              disabled={!x.connected}
              className={classes.desktopLocation}
            >
              <RoomIcon />
            </IconButton>
          </td>
        </tr>
      ))

  return (
    <>
      <Card title={strings.users}>
        <SearchPanel
          onChanged={(query, group) => {
            setQuery(query)
            setGroup(group)
          }}
          groups={userGroupsList}
          showNew={
            !usersList?.length && query.match(/^[a-z0-9_]{4,20}$/) !== null
          }
          onNew={() => {
            newUser(query, group)
          }}
        />
        <GroupForm groupId={group} groupType="user" />
      </Card>
      <Paper className={classes.result}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th style={{ width: 33, borderBottom: 'none' }}>&nbsp;</th>
              <th>{strings.name}</th>
              <th>{strings.groupName}</th>
              {/* <th>{strings.nationalCode}</th> */}
              <th />
            </tr>
          </thead>
          <tbody>{dataTable}</tbody>
        </table>
      </Paper>
    </>
  )
}

function Row({ children }: any) {
  return (
    <tr>
      <td colSpan={4} style={{ textAlign: 'center' }}>
        {children}
      </td>
    </tr>
  )
}

const useStyles = makeStyles((theme) => ({
  search: {
    flex: '0 1 60px',
    width: '100%',
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: '#fff',
    '& .MuiButtonBase-root': {
      padding: theme.spacing(0.75),
    },
    '& .tags': {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      '& .MuiButtonBase-root': {
        borderRadius: theme.spacing(2),
        marginRight: theme.spacing(1),
        fontSize: '0.6rem',
        fontWeight: 'normal',
        padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
      },
    },
  },
  result: {
    flex: '1 1 auto',
    width: '100%',
    marginTop: theme.spacing(1),
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& tr > td': {
      paddingTop: theme.spacing(1),
      cursor: 'pointer',
    },
    // '& tr:hover td': {
    //   backgroundColor: '#f8f8f8',
    // },
    '& th': {
      borderBottom: '1px solid lightgray',
      fontWeight: 'normal',
      textAlign: 'left',
      paddingBottom: theme.spacing(0.5),
    },
    '& tr th:last-child, & tr td:last-child': {
      textAlign: 'right',
    },
    '& .MuiSvgIcon-root': {
      marginTop: theme.spacing(1),
    },
  },
  mobileLocation: {
    padding: 1,
    '& svg': {
      marginTop: 0,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  desktopLocation: {
    padding: 1,
    '& svg': {
      marginTop: 0,
    },
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'unset',
    },
  },
}))
